import { IAutocompleteOption } from './autocomplete.model';
import { createSearchRegex, scoreMatch } from './match-regex/match-regex';
export interface IAutocompleteSearchKeyFilter {
  filter(
    options: IAutocompleteOption[],
    searchKey: string
  ): IAutocompleteOption[];
}

export class DefaultAutocompleteSearchKeyFilter
  implements IAutocompleteSearchKeyFilter
{
  filter(options: IAutocompleteOption[], searchKey: string): any {
    if (!options || !searchKey) {
      return options;
    }
    searchKey = searchKey.toLowerCase();

    const regEx: '' | RegExp = searchKey && createSearchRegex(searchKey);
    return (
      options
        .map((opt) => ({
          ...opt,
          nameMatch: (regEx as RegExp).exec(opt.text),
          aliasMatch:
            opt.aliases &&
            opt.aliases
              .map((a: any) => (regEx as RegExp).exec(a))
              .find((res: any) => !!res),
        }))
        .filter((x) => {
          return x.nameMatch || x.aliasMatch;
        })
        .sort((a: IAutocompleteOption, b: IAutocompleteOption) => {
          if (
            a.text.toLowerCase().startsWith(searchKey) &&
            !b.text.toLowerCase().startsWith(searchKey)
          ) {
            return -1;
          }
          if (
            !a.text.toLowerCase().startsWith(searchKey) &&
            b.text.toLowerCase().startsWith(searchKey)
          ) {
            return 1;
          }

          return scoreMatch(b.nameMatch, b.aliasMatch) -
          scoreMatch(a.nameMatch, a.aliasMatch);
        })
        .splice(0, 10)
        .map((opt) => {
          if (!(regEx as RegExp).test(opt.text)) {
            const filteredAliases = opt.aliasMatch
                ? opt.aliasMatch.filter((alias) => (regEx as RegExp).test(alias))
                : [];
            if (filteredAliases.length > 0) {
                // sometimes the name is part of aliases
                if (opt.text !== filteredAliases[0]) {
                    opt.text =
                        opt.text + ' (' + filteredAliases[0] + ')';
                }
            }
        }
          return opt;
        })
    );
  }
}
